
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import { useChat } from '../../../Hooks/UseChat'

import './HeaderChatMenu.scss'

const HeaderChatMenu = () => {

  const location = useLocation().pathname;

  const { enabled: chatsEnabled, newChats, currentChat } = useChat()

  if (!chatsEnabled) return null

  return (
    <Link className="link-to-chat" to={`/chat${currentChat ? '/' + currentChat._id : ''}`}>
      <div className={`right-dropdown svg-icon-menu cursor-pointer ${location == '/chat' ? 'active' : ''}`}>
        <div className="svg-icon-container">
          {newChats > 0 && (
            <span className="new-chats-badge badge badge-primary">
              {newChats}
            </span>
          )}

          <span className={`icon-mensajes${location == '/chat' ? '_full' : ''}`}></span>
        </div>
      </div>
    </Link>
  )
}

export default HeaderChatMenu
